import { render, staticRenderFns } from "./CampaignDonations.vue?vue&type=template&id=67a8e4de&scoped=true&"
import script from "./CampaignDonations.vue?vue&type=script&lang=js&"
export * from "./CampaignDonations.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDonations.vue?vue&type=style&index=0&id=67a8e4de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8e4de",
  null
  
)

export default component.exports